let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("3kHns"), load("3JzPO"), load("eacuJ"), load("cUtrS")]).then(() => parcelRequire('9dU2w'));